module.exports = __webpack_public_path__ + "static/media/GaugeChart.599eff69.svg";